import { AddressPinFilled24 } from '@vinted/monochrome-icons'
import { Icon } from '@vinted/web-ui'

type Props = {
  lat: number
  lng: number
}

// google-map-react is using lat and lng internally
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const AddressMarker = ({ lat, lng }: Props) => (
  <div className="pickup-point-map__address-pin">
    <Icon
      name={AddressPinFilled24}
      color="warning-default"
      aria={{
        'aria-hidden': 'true',
      }}
      testId="address-pin"
    />
  </div>
)

export default AddressMarker
